import { Component } from '@angular/core';
import { IonicPage, Events } from 'ionic-angular';

@IonicPage()
@Component({
	templateUrl: 'tabs.html'
})
export class TabsPage {

	tab1Root: any = 'ShopPage';
	tab2Root: any = 'NewsPage';
	// tab2Root: any = 'PlacesPage';
	tab3Root: any = 'AiutoPage';
	// tab4Root: any = 'ToolPage';
	tab5Root: any = 'AccountPage';

	tab2Badge: string = '';

	constructor(public events: Events) {
		// se non è scelto il luogo di ritiro carica la pagina shop-geo
		if( true ) {
			// this.tab1Root = 'CheckoutModalPage';
			// this.tab1Root = 'AccountPage';
			// this.tab1Root = 'ShopGeoPage';
		}
		events.subscribe('news:new', () => this.tab2Badge = '1');
		events.subscribe('news:cancel', () => this.tab2Badge = '');
	}
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts